export default __webpack_public_path__ + "static/media/samurai.1486efd2.jpg";